import React, { useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import AttachmentComponent from './AttachmentComponent';
import { DEFAULT_FILE_UPLOAD_SIZE_LIMIT_IN_MB } from '../../../HelperMethods/constants';
import { formikPropType } from '../../../common/prop-types';

export default function FormikEnabledAttachment({ attributeObj, formik, isCommonFieldDisabled }) {
  const err = _.get(formik, `errors.${attributeObj.id}`);
  const { allowedFormat, label: fieldName, disabled, id: attributeObjId } = attributeObj;
  const fileSizeLimitInMB = attributeObj.sizeLimit || DEFAULT_FILE_UPLOAD_SIZE_LIMIT_IN_MB;
  const uploadedFileObj = _.get(formik.values, attributeObjId);
  const onChange = useCallback(
    (uploadFileObject) => {
      formik.setFieldValue(attributeObjId, uploadFileObject, false);
    },
    [attributeObjId, formik]
  );
  return (
    <AttachmentComponent
      allowedFormats={allowedFormat}
      disabled={isCommonFieldDisabled || disabled}
      fileSizeLimitInMB={fileSizeLimitInMB}
      onChange={onChange}
      errorMessage={err}
      fieldName={fieldName}
      uploadedFile={uploadedFileObj}
      isRequired={attributeObj?.isRequired}
      isRequiredOnCreation={attributeObj?.isRequiredOnCreation}
      isCreate={!attributeObj?.taskId}
    />
  );
}
FormikEnabledAttachment.propTypes = {
  attributeObj: PropTypes.object.isRequired,
  formik: formikPropType.isRequired,
  isCommonFieldDisabled: PropTypes.bool.isRequired,
};
